module.exports = __webpack_public_path__ + "img/wizard_small.7b5021dc.png";